/** Pure event parser. Browser data supplies hints only; backend verifies account membership. */
export function signupEvent(origin, data) {
  if (!['https://www.facebook.com', 'https://web.facebook.com'].includes(origin)) return null;
  try {
    const value = typeof data === 'string' ? JSON.parse(data) : data;
    if (value?.type !== 'WA_EMBEDDED_SIGNUP' || value.event !== 'FINISH') return null;
    const { waba_id, phone_number_id } = value.data ?? {};
    if (!/^\d{1,128}$/.test(waba_id ?? '') || !/^\d{1,128}$/.test(phone_number_id ?? '')) return null;
    return { wabaId: String(waba_id), phoneId: String(phone_number_id) };
  } catch { return null; }
}
